import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'

export interface BulkOperation {
  id: string
  operation_type: string
  total_selected: number
  successful_count: number
  failed_count: number
  operation_details: any
  errors: string[]
  performed_by?: string
  started_at: string
  completed_at?: string
  created_at: string
}

export function useBulkOperations() {
  return useQuery({
    queryKey: ['bulk-operations'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('mailbox_bulk_operations')
        .select('*')
        .order('started_at', { ascending: false })
        .limit(20)

      if (error) throw error
      return data as BulkOperation[]
    },
    refetchInterval: 5000, // Auto-refresh every 5 seconds
    refetchIntervalInBackground: false, // Only refresh when tab is active
  })
}

export async function logBulkOperation(
  operationType: string,
  totalSelected: number,
  operationDetails: any = {},
  performedBy: string = 'System'
) {
  const { data, error } = await supabase
    .from('mailbox_bulk_operations')
    .insert({
      operation_type: operationType,
      total_selected: totalSelected,
      operation_details: operationDetails,
      performed_by: performedBy,
    })
    .select()
    .single()

  if (error) throw error
  return data
}

export async function updateBulkOperation(
  id: string,
  updates: {
    successful_count?: number
    failed_count?: number
    errors?: string[]
    completed_at?: string
    operation_details?: any
  }
) {
  const { error } = await supabase
    .from('mailbox_bulk_operations')
    .update({
      ...updates,
      completed_at: updates.completed_at || new Date().toISOString(),
    })
    .eq('id', id)

  if (error) throw error
}